import { AppActorContext } from '@/components/AppActorProvider/AppActorProvider'
import type { Config } from '@/state/AppConfig'
import { configs } from '@/state/AppConfig'
import { AppContext } from '@/state/AppStateMachine'

type StateValue = string | { [key: string]: StateValue }

// This function returns a single string representing the full nested path.
export function stateValueToString(stateValue: StateValue): string {
  if (typeof stateValue === 'string') return stateValue
  // Recursively join keys and values
  return Object.entries(stateValue)
    .map(([key, value]) => `${key}.${stateValueToString(value)}`)
    .join('.')
}

export function useAppState() {
  const actor = AppActorContext.useActorRef()
  const context = AppActorContext.useSelector((state) => state.context) as AppContext
  const state = AppActorContext.useSelector((state) => state)

  const persona = context?.persona || 'pedro'
  const backUrl = context?.backUrl || null
  const scenario = context?.scenario
  const scenarioUnitName = scenario.current !== null && scenario.current !== undefined ? `_${scenario.current}` : ''
  const summary = context?.summary
  const answers = context?.answers
  const personaConfig: Config | null = configs.find((list) => list.persona === persona) ?? null

  return {
    actor,
    context,
    state,
    persona,
    personaConfig,
    scenario,
    scenarioUnitName,
    summary,
    answers,
    backUrl,
  }
}
